import { getOptimizedImagePathFromHash } from "@r360/library";
import React from "react";
import useAppSelector from "../../hooks/useAppSelector";
import { currencySelector } from "../../selectors/Selectors";
import { TExternalProduct, TImage, TReservationResult, TReservationTypeLid } from "../../store/types";
import { ProductCard } from "../ProductCard";

type TExternalProducts = {
    show: boolean;
    reservationTypeId: TReservationTypeLid;
    externalProducts: TExternalProduct[];
    reservationResult?: TReservationResult;
};

export const ExternalProducts = ({
    show = true,
    reservationTypeId,
    externalProducts,
    reservationResult,
}: TExternalProducts) => {
    const currency = useAppSelector(currencySelector);

    if (!show || externalProducts.length === 0 || !reservationResult) {
        return null;
    }

    return (
        <>
            {externalProducts.map(product => {
                const images: TImage = {
                    url: getOptimizedImagePathFromHash(product.image_hash) ?? "",
                };

                return (
                    <ProductCard
                        key={product.id}
                        reservationType={reservationTypeId.toString()}
                        title={product.translations.title}
                        description={product.translations.description}
                        images={[images]}
                        currency={currency}
                        isExternalProduct
                        externalProductLink={product.translations.link}
                        externalProductAccessibility={product.translations.img_accessibility}
                    />
                );
            })}
        </>
    );
};
